import {JacksonType, MapType} from "@sonner/jackson-service-v2";
import {MenuMapItemTO} from "./menu.map.item.to";

@JacksonType("MenuMapTO")
export class MenuMapTO {

  @MapType({valueType: "MenuMapItemTO"})
  itens: Map<String, MenuMapItemTO[]>;
}
